import { useEffect } from 'react';
import { useShallow } from 'zustand/react/shallow';
import useProductDetailsStore from '../../../../../../../stores/ProductDetails/productDetails.store';
import { CompactAvailability } from '../../../../../ProductTypes';
import { UseResetUnavailableAvailabilityParams } from '../types/useResetUnavailableAvailability.types';

const COMPACT_AVAILABILITIES = Object.values(CompactAvailability);

const useResetUnavailableAvailability = ({
  availabilities,
  isFiltersReady,
}: UseResetUnavailableAvailabilityParams) => {
  const { productGridParams, handleChangeProductGridParams } = useProductDetailsStore(
    useShallow((state) => ({
      productGridParams: state.productGridParams,
      handleChangeProductGridParams: state.handleChangeProductGridParams,
    })),
  );

  const { availability } = productGridParams;
  const isCompactAvailability = COMPACT_AVAILABILITIES.some((compact) => compact === availability);
  const isSelectedAvailabilityUnavailable =
    isFiltersReady &&
    isCompactAvailability &&
    availabilities.length > 0 &&
    !availabilities.some((available) => available === availability);

  useEffect(() => {
    if (!isSelectedAvailabilityUnavailable) {
      return;
    }

    handleChangeProductGridParams({
      ...productGridParams,
      availability: undefined,
      deliveryWindowIds: undefined,
      deliveryWindowsSnapshot: undefined,
    });
  }, [isSelectedAvailabilityUnavailable, productGridParams, handleChangeProductGridParams]);
};

export default useResetUnavailableAvailability;
